const ProviderLinkActionTypes = {
  SET_PROVIDER_LINK_SELECTED_FILTER: "SET_PROVIDER_LINK_SELECTED_FILTER",
};
  
export default ProviderLinkActionTypes;
